import ContentPage from "./ContentPage";
import "./BIMIndustry.css";
import Button from "./Button";
import { ReactComponent as RightArrow } from "./static/icons/RightArrow.svg";
import Highlighter from "./Highlighter";
import { ReactComponent as LinkArrow } from "./static/icons/LinkArrow.svg";
import { goToPage } from "./Slide";
import LinkButton from "./LinkButton";
import Plugin from "./static/images/SolibriPlugin.png";
import Editor from "./static/images/SolibriEditor.png";
import DesignSystem from "./static/images/DesignSystem.png";
import AnimatedDiv from "./AnimatedDiv";

import { useState } from "react";
import Modal from "./Modal";

function BIMIndustry() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      {modalOpen && (
        <Modal title="WHAT THE HELL IS BIM?" onClose={closeModal}>
          <p>
            You could develop a perfect 3D replica of a banana in a digital
            modelling programme, but that's only one kind of representation of
            the fruit. It doesn't include any of the fruit's data; for example,
            its sugar content, calories, use-by-date, country of origin, and so
            on. The 3D object on its own isn't enough to represent the fruit. It
            isn't Banana Information Modelling. That's the difference between 3D
            CAD and true information modelling.
          </p>
        </Modal>
      )}
      <ContentPage>
        <AnimatedDiv>
          <h2>Solibri Inside: Plugin and Editor</h2>

          <h3>Role</h3>
          <p>
            Product Design Lead | Product Designer| UX Researcher | UX Writer{" "}
          </p>
          <h3>First things first. Meet Solibri Inside.</h3>
          <p>
            Solibri Inside helps architects fix errors as they design, which
            means lower risk of extra costs, delays and rework. With Solibri
            Inside all of the team members have access to shared company or
            project-wide resources.{" "}
          </p>
          <h3>Disclaimer</h3>
          <p>
            Solibri Inc. operates in the industry of Building Information
            Modelling aka BIM. If you'd like to get some more context, here you
            go.
          </p>
          <Button
            variant="complex"
            text="WHAT THE HELL IS BIM?"
            icon={<RightArrow />}
            onClick={openModal}
          />
        </AnimatedDiv>
        <AnimatedDiv>
          <h3>Challenges</h3>
          <p>
            <Highlighter text="1. Outdated processes" />
          </p>
          <p>
            The current process of sending building models back and forth for
            revisions via email or USB-drive can cause delays and rework in a
            project. Solibri Inside aims to streamline this process by allowing
            architects to perform checks themselves and giving BIM managers the
            ability to set checks for the team. All of that in cloud,
            in-real-time.
          </p>
          <p>
            <Highlighter text="2. Complex concepts and technical terms" />
          </p>
          <p>
            Features and capabilities of the product are industry-specific,
            technical, but very powerful. Users need to feel that the product
            helps them to make their workflow easier and more efficient, without
            being overwhelmed by the complexity of features.
          </p>
        </AnimatedDiv>
        <AnimatedDiv>
          <h3>Process</h3>
          <p>
            From early concept stage to MVP launch the design process took 1,5
            years.
          </p>
          <p>
            Solibri Inside consists of 2 parts; The Plugin, which seamlessly
            integrates into a model design tool where architects work, and the
            Editor where users can specify the requirements and criteria against
            which they want their models to be checked.
          </p>
        </AnimatedDiv>
        <AnimatedDiv>
          {/* Plugin card */}
          <div className="ContentBlock">
            <div className="imageContainer">
              <img className="SolibriPlugin" src={Plugin}></img>
            </div>
            <div className="TextContent">
              <h3>Solibri Inside: Plugin</h3>
              <p>
                Plugin - a product that integrates Solibri Inside
                functionalities into existing modelling tools that architects
                use, such as Archicad.
              </p>
              <p>
                For the launch Plugin was introduced for Archicad, Allplan and
                Vectorworks.
              </p>{" "}
              <div className="CardLinkButtonContainer">
                <LinkButton
                  text="SEE THE CASE"
                  icon={<LinkArrow />}
                  onClick={() => goToPage("/case1/plugin")}
                ></LinkButton>
              </div>
            </div>
          </div>
        </AnimatedDiv>
        {/* Editor card */}
        <AnimatedDiv>
          <div className="ContentBlock">
            <div className="imageContainer">
              <img className="SolibriEditor" src={Editor}></img>
            </div>
            <div className="TextContent">
              <h3>Solibri Inside: Editor</h3>
              <p>
                Solibri Inside Editor is a browser-based tool for BIM
                Managers/Coordinators to set project requirements. The
                requirements can be instantly shared with the rest of the team.
                This helps ensure all models in the project meet the best QA
                standards and criteria.
              </p>{" "}
              <div className="CardLinkButtonContainer">
                <LinkButton
                  marginBottom={85}
                  backgroundMargin={0}
                  text="SEE THE CASE"
                  icon={<LinkArrow />}
                  onClick={() => goToPage("/case1/editor")}
                ></LinkButton>
              </div>
            </div>
          </div>
        </AnimatedDiv>
        {/* Design system card */}
        <AnimatedDiv>
          <div className="ContentBlock DesignSystem">
            <div className="imageContainer">
              <img className="SolibriEditor" src={DesignSystem}></img>
            </div>
            <div className="TextContent">
              <h3>Solibri Inside: Design System</h3>
              <p>
                Through the years Solibri existed without any streamlined design
                guidelines. In 2021, the company decided to introduce a new,
                revolutionary cloud-based Solibri Inside.The design system was
                needed to help streamline the process of creating accessible
                products.
              </p>
              <div className="CardLinkButtonContainer">
                <LinkButton
                  marginBottom={85}
                  backgroundMargin={0}
                  text="SEE THE CASE"
                  icon={<LinkArrow />}
                  onClick={() => goToPage("/case1/designsystem")}
                ></LinkButton>
              </div>
            </div>
          </div>
        </AnimatedDiv>
      </ContentPage>
    </>
  );
}

export default BIMIndustry;
